import { useState, useEffect } from 'react';
type Images = Record<string, string> | string[];

export default (images: Images) => {
  (window as Application).IMAGES = {};
  const imageArray = Array.isArray(images);

  const [loaded, setLoaded] = useState(false);
  const appImages = (window as Application).IMAGES;

  const [loadedImages, setLoadedImages] = useState(0);
  const onLoad = () => setLoadedImages((state) => ++state);
  const { length } = (imageArray && images) || Object.keys(images);

  const preloadImage = (path: string) => {
    const image = new Image();
    appImages[path] = image;
    image.onload = onLoad;
    image.src = path;
  };

  useEffect(() => {
    ((imageArray && images) || Object.values(images)).forEach((image) =>
      preloadImage(image)
    );
  }, []);

  useEffect(
    // React.StrictMode will double "loadedImages" count:
    () => setLoaded(!!length && length <= loadedImages),
    [images, loadedImages]
  );

  return loaded;
};
